import { string } from "prop-types";
import { useCallback } from "react";

import styled from "styled-components";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { ButtonWrapper } from "CrossFeatureComponents/MemberToolbar/components/shared";
import FnrTypography from "FnrTypography";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTappyShrink from "UI/FnrTappyShrink";

import externalNavigate from "Utilities/externalNavigate";

import { useIsOnProfilePage, usePathToProfile } from "./stateHooks";

const DisplayComponent = ({ color }) => {
  const { isThin } = useMemberToobarContext();
  return (
    <FnrTappyShrink>
      <EditProfileDisplayContainer>
        <FnrTypography
          color={color}
          fontSize={isThin ? "xs" : "sm"}
          type="copy"
        >
          Edit Profile
        </FnrTypography>
        <FnrContainedIcon
          color={color}
          icon="fa-external-link fas"
          data-cy="MiniProfile_GoToProfileButton"
          size={isThin ? "xs" : "sm"}
          yCorrection={isThin ? -2 : -1}
        />
      </EditProfileDisplayContainer>
    </FnrTappyShrink>
  );
};

DisplayComponent.propTypes = { color: string };

const EditProfileButton = () => {
  const pathToProfile = usePathToProfile();

  const isOnProfilePage = useIsOnProfilePage();
  const handleGoToProfile = useCallback(() => {
    externalNavigate(pathToProfile, "_self");
  }, [pathToProfile]);

  return (
    <EditProfileButtonWrapper
      onClick={handleGoToProfile}
      disabled={isOnProfilePage}
      DisplayComponent={DisplayComponent}
    />
  );
};

const EditProfileButtonWrapper = styled(ButtonWrapper)`
  display: flex;
  align-items: center;
  max-width: fit-content;
  margin-left: -12px;
  padding: 0;
  height: 28px;
`;

const EditProfileDisplayContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 12px;
  padding-right: 4px;
`;

export default EditProfileButton;
